import React from 'react';
import { useProjects } from '../context/ProjectContext';
import ListView from '../components/views/ListView';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const SignedOff = () => {
  const { projects, deleteProject } = useProjects();
  const signedOffProjects = projects.filter(p => p.signed_off === true);

  return (
    <div className="space-y-6">
      <div className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 rounded-2xl p-6 flex items-center justify-between shadow-sm">
        <div className="flex items-center gap-4">
          <div className="p-4 bg-green-50 dark:bg-green-900/20 text-green-600 rounded-2xl">
            <SafeIcon icon={FiIcons.FiCheckCircle} className="text-2xl" />
          </div>
          <div>
            <h2 className="text-xl font-bold dark:text-white">Signed Off Projects</h2>
            <p className="text-gray-500 dark:text-gray-400">Projects that have received final approval and are ready for delivery.</p>
          </div>
        </div>
        <div className="text-right">
          <span className="block text-2xl font-bold text-green-600">{signedOffProjects.length}</span>
          <span className="text-xs text-gray-400 uppercase font-semibold">Total Approved</span>
        </div>
      </div>
      {signedOffProjects.length > 0 ? (
        <ListView projects={signedOffProjects} onEdit={() => {}} onDelete={deleteProject} />
      ) : (
        <div className="text-center py-24 bg-white dark:bg-gray-800 rounded-3xl border border-dashed border-gray-200 dark:border-gray-700">
          <div className="w-20 h-20 bg-gray-50 dark:bg-gray-900 rounded-full flex items-center justify-center mx-auto mb-4">
            <SafeIcon icon={FiIcons.FiAward} className="text-4xl text-gray-300" />
          </div>
          <h3 className="text-lg font-medium text-gray-900 dark:text-white">No Signed Off Projects</h3>
          <p className="text-gray-500 max-w-xs mx-auto mt-2">When projects are approved by stakeholders, they will appear here for final processing.</p>
        </div>
      )}
    </div>
  );
};

export default SignedOff;